import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { APP_URL } from '../env';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleFeaturesClick = (e: React.MouseEvent) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const el = document.getElementById('features');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: scrolled ? 'rgba(15,23,42,0.98)' : 'rgba(15,23,42,0.95)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${scrolled ? 'rgba(148,163,184,0.15)' : 'transparent'}`,
      transition: 'border-color 0.3s, background 0.3s',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <img src="/logo192.png" alt="PRETTIFAI logo" style={{ width: 32, height: 32, borderRadius: 6 }} />
          <span style={{ fontSize: '1.1rem', fontWeight: 800, letterSpacing: '0.08em', color: '#f9fafb' }}>PRETTIFAI</span>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 32 }} className="desktop-nav">
          <Link to="/#features" onClick={handleFeaturesClick} style={{ color: '#94a3b8', fontSize: '0.95rem', fontWeight: 500, transition: 'color 0.2s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
            onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}>
            Features
          </Link>
          <Link to="/pricing" style={{ color: '#94a3b8', fontSize: '0.95rem', fontWeight: 500, transition: 'color 0.2s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#f9fafb')}
            onMouseLeave={e => (e.currentTarget.style.color = '#94a3b8')}>
            Pricing
          </Link>
          <a href={APP_URL} style={{
            padding: '8px 20px',
            background: 'var(--primary-gradient)',
            color: 'white',
            borderRadius: 8,
            fontSize: '0.9rem',
            fontWeight: 600,
            transition: 'opacity 0.2s',
          }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.85')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}>
            Sign In
          </a>
        </div>

        {/* Hamburger */}
        <button onClick={() => setMenuOpen(!menuOpen)} style={{
          display: 'none',
          background: 'none',
          border: 'none',
          color: '#f9fafb',
          padding: 8,
          cursor: 'pointer',
        }} className="hamburger" aria-label="Toggle menu">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          background: 'rgba(15,23,42,0.98)',
          borderTop: '1px solid rgba(148,163,184,0.15)',
          padding: '16px 24px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }} className="mobile-menu">
          <Link to="/#features" onClick={handleFeaturesClick} style={{ color: '#94a3b8', fontSize: '1rem', fontWeight: 500 }}>Features</Link>
          <Link to="/pricing" style={{ color: '#94a3b8', fontSize: '1rem', fontWeight: 500 }}>Pricing</Link>
          <a href={APP_URL} style={{
            padding: '12px 20px',
            background: 'var(--primary-gradient)',
            color: 'white',
            borderRadius: 8,
            fontSize: '1rem',
            fontWeight: 600,
            textAlign: 'center',
          }}>Sign In</a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
